"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setMemberTokenIfAvailable = exports.getMemberToken = exports.removeMemberToken = exports.setMemberToken = exports.setUseCookies = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var memberAuthTokenName = "_ms-mid";
function isLocalStorageAvailable() {
    try {
        localStorage.setItem("test", "test");
        localStorage.removeItem("test");
        return true;
    }
    catch (e) {
        return false;
    }
}
var localStorageAvailable = isLocalStorageAvailable();
var useCookies = false;
var setUseCookies = function () {
    useCookies = true;
};
exports.setUseCookies = setUseCookies;
var setMemberToken = function (token, expires) {
    if (localStorageAvailable && !useCookies) {
        localStorage.setItem(memberAuthTokenName, token);
    }
    else {
        js_cookie_1.default.set(memberAuthTokenName, token, {
            expires: (expires && Number(expires)) || 14,
            sameSite: "strict",
        });
    }
};
exports.setMemberToken = setMemberToken;
var removeMemberToken = function () {
    if (localStorageAvailable) {
        localStorage.removeItem(memberAuthTokenName);
    }
    js_cookie_1.default.set(memberAuthTokenName, "", {
        expires: -1,
        sameSite: "strict",
    });
};
exports.removeMemberToken = removeMemberToken;
var getMemberToken = function () {
    if (localStorageAvailable && !useCookies) {
        var memAuthToken = localStorage.getItem(memberAuthTokenName);
        if (memAuthToken)
            return memAuthToken;
    }
    // todo: it's safe to make this an else in 2 weeks
    // fallback to cookie -> this is to prevent folks from having to log in again
    return js_cookie_1.default.get(memberAuthTokenName);
};
exports.getMemberToken = getMemberToken;
var setMemberTokenIfAvailable = function () {
    if (typeof window !== "undefined") {
        var urlParams = new URLSearchParams(window.location.search);
        var memberToken = urlParams.get("memberToken");
        if (memberToken)
            (0, exports.setMemberToken)(memberToken);
    }
};
exports.setMemberTokenIfAvailable = setMemberTokenIfAvailable;
